import { hasTranslationKey, t } from './i18n';

export function getTranslatedError(errorCode: string) {
  const key = `common.serverError.${errorCode}`;
  return hasTranslationKey(key) ? t(key) : errorCode;
}
